<template>
  <div class="phases-manager">
    <b-modal ref="manageProgressModal" hide-footer>
      <template #modal-header="{ close }">
        <h5>Manage Class Progress</h5>
        <div class="clickable" @click="close()">
          <i class="fas fa-times fa-lg"></i>
        </div>
      </template>
      <div v-if="loading">
        <b-spinner></b-spinner>
      </div>
      <b-container v-else-if="!currentEvent"> No teacher triggerable events available</b-container>
      <b-container v-else>
        <b-row>
          <b-col><h4> Events </h4></b-col>
          <b-col class="align-right" md="auto">
            <span class="phases-manager"> <!-- Next and Previous buttons -->
              <span id="day"> Event {{ eventIndex + 1}}/{{events.length}}</span>
              <b-button size="sm" variant="home-primary" :disabled="eventIndex === 0" @click="previousEvent()"><i class="fas fa-chevron-left"></i></b-button>
              <b-button size="sm" variant="home-primary" :disabled="eventIndex === events.length - 1" @click="nextEvent()"><i class="fas fa-chevron-right"></i></b-button>
            </span>
          </b-col>
        </b-row>
        <br>
        <div>
          <strong> {{currentEvent.name}}, Day {{currentEvent.phase + 1}}</strong>
          <p>
            {{currentEvent.description}}
          </p>
        </div>
      </b-container>
      <br>
      <div class="phases-manager" v-if="currentEvent">
        <div class="align-right"> 
        <b-button 
          variant="outline-home-primary"
          size="sm"
          @click="hidePhases"
        >Cancel</b-button>
        <b-button 
          v-if="triggeringEvent" 
          variant="home-primary"
          size="sm" 
          disabled
         > 
          <b-spinner small></b-spinner>
            Triggering Event...
        </b-button>
        <b-button 
          v-else-if="alreadyTriggered"
          variant="home-primary"
          size="sm" 
          @click="triggerEvent(currentEvent.event_id)">
            <i class="fas fa-check" /> Triggered {{currentEventCompleteTime ? 'on ' + new Date(currentEventCompleteTime).toLocaleTimeString([], {year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit'}) : ''}}
          </b-button>
        <b-button 
          v-else
          variant="home-primary"
          size="sm" 
          @click="triggerEvent(currentEvent.event_id)">
          Trigger
        </b-button>
        </div>
      </div>
    </b-modal>
    <b-button variant="outline-home-primary" class="inline w-100" @click="showPhases">Manage Class Progress</b-button>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'PhasesManager',
  data() {
    return {
      events: [],
      pcsList: [],
      loading: true,
      eventIndex: 0,
      triggeringEvent: false,
      completedEvents: []
    }
  },
  props: ['pcsSelect', 'classSelect', 'updateSuccessful', 'updateUnsuccessful'],
  computed: {
    currentEvent: function() {
      return this.events[this.eventIndex]
    },
    currentEventCompleteTime: function() {
      let currentEvent = this.completedEvents.find(event => event.eventId === this.currentEvent.event_id)
      return currentEvent ? currentEvent.completeTime : null
    },
    alreadyTriggered: function() {
      return (this.completedEvents.findIndex(event => event.eventId === this.currentEvent.event_id) !== -1)
    }
  },
  watch: {
    pcsSelect: function() {
      this.loading = true;
      this.loadPCS()
    }
  },

  created: function() {
    this.loading = true;
    this.loadPCS()
  },

  methods: {
    triggerEvent(eventId) {
      this.triggeringEvent = true
      axios.post('/api/teacher/progressPhase', {
        params: {
          pcs: this.pcsSelect.pcs_id,
          class: this.classSelect.class_id,
          eventId: eventId,
        },
      }).then(response => {
        if (response.status){
          this.updateSuccessful('Event ' + this.currentEvent.name + ' has been triggered for all groups in your class')
          this.getClassProgress() 
          this.hidePhases()
        }
        else { 
          this.updateUnsuccessful(`Server Error`)
        }
        this.triggeringEvent = false
      })
    },

    loadPCS: function(thenRun) {
      let that = this;
      axios.post('/api/teacher/load_teacher_events', {
        params: {
          pcs: this.pcsSelect.pcs_id,
        },
      }).then(function (response) {
        // Save events into usable dictionary
        that.events = response.data.sort((a, b) => a.phase - b.phase || a.order - b.order)
        // Get Completed Teacher Triggered Events
        that.getClassProgress()
        that.loading = false
      })
    },

    getClassProgress: function() {
      axios.post('/api/get_class_progress', {
        params: {
          pcs: this.pcsSelect.pcs_id,
          class: this.classSelect.class_id,
        }
      }).then(response => {
        this.completedEvents = response.data
        // Start modal on first non triggered event
        let startEventIndex = this.events.findIndex(event => this.completedEvents.findIndex(completed => completed.eventId === event.event_id) === -1)
        if (startEventIndex !== -1){
          this.eventIndex = startEventIndex
        }
        else if (this.events.length === this.completedEvents.length){
          this.eventIndex = this.events.length - 1
        }
      })
    },
    showPhases: function() {
      this.$refs['manageProgressModal'].show()
    },
    hidePhases: function() {
      this.$refs['manageProgressModal'].hide()
    },
    previousEvent: function() {
      if (this.eventIndex > 0) {
        this.eventIndex--
      }
    },
    nextEvent: function() {
      if(this.eventIndex < this.events.length - 1){
        this.eventIndex++
      }
    }
  },
}
</script>
<style scoped lang="scss">
.phases-manager::v-deep {
  @import './teacherPanel.scss';
}
.clickable:hover {
  cursor: pointer;
}
</style>